// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"About-module--wrapper--3GsTg","container":"About-module--container--1wwjs","link":"About-module--link--Rg58l","photo":"About-module--photo--2Kx_9"};